import $ from 'jquery';
import Page from './page';

const DOMAIN = 'http://25events.woman.ru/';

function checkTotal(count, data) {
	const length = 25 * 3;

	if (count === length) {
		$('.preloader').removeClass('active');
		const page = new Page(data);
	}
}

$(() => {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);

	window.addEventListener('resize', () => {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	});

	let count = 0;

	$.getJSON('./data/get_data.json', (data) => {
		let count = 0;
		data.map((item, i) => {
			const img = new Image();
			img.src = `${DOMAIN}${item.background}`;
			$('.s__bgs').append(`<div class="s__bg" style="background-image: url(${DOMAIN}${item.background});"></div>`);
			img.onload = function () {
				count += 1;
				checkTotal(count, data);
			};
		});
		data.map((item, i) => {
			const img = new Image();
			img.src = `${DOMAIN}${item.mobile_photo}`;
			$('.slider-m').append(`<div class="slider-m__slide" style="background-image: url(${DOMAIN}${item.mobile_photo});"></div>`);
			img.onload = function () {
				count += 1;
				checkTotal(count, data);
			};
		});
		data.map((item, i) => {
			const img = new Image();
			img.src = `${DOMAIN}${item.image}`;
			$('.slider').append(`<div class="slider__slide" style="background-image: url(${DOMAIN}${item.image});"></div>`);
			img.onload = function () {
				count += 1;
				checkTotal(count, data);
			};
		});
	});
});



// WEBPACK FOOTER //
// ./app/scripts/app.js